// extracted by mini-css-extract-plugin
export default {"container":"_8756c3c5119b9cbf","body":"_17319c3f5c70cd7d","text":"_99feb1dca73cd84f","pre":"fadd22c3dd6b3ab9","post":"f0d9c62b88aacffe"};